import { render, staticRenderFns } from "./ReturnTop.vue?vue&type=template&id=5d1b2ce7&scoped=true&"
import script from "./ReturnTop.vue?vue&type=script&lang=js&"
export * from "./ReturnTop.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTop.vue?vue&type=style&index=0&id=5d1b2ce7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b2ce7",
  null
  
)

export default component.exports